import React from 'react';
import { usePortalCreateContext } from '../../../../jira-common/context';
// Renders the Knowledge base article suggestions on the portal create page and null on other pages
export const KbSuggestionFieldWrapper = ({
  questionStore
}) => {
  const {
    KbSuggestionField
  } = usePortalCreateContext();
  return questionStore.formQuestion.jiraField === 'summary' && KbSuggestionField ? /*#__PURE__*/React.createElement(KbSuggestionField, null) : null;
};